import { useCallback } from 'react';
import {
  openAiPlatform,
  AiPlatformHandoffOptions,
} from 'app/helpers/aiPlatformHandoff';
import { useJusGptV2Access } from 'app/services/jusGptAccess';

/**
 * Desvio pra plataforma de IA, a mesma regra em todo lugar que leva ao JusGPT
 * (item do menu lateral, console da dashboard): quem o backend liberou abre o
 * front novo em aba nova em vez de navegar pro `/gpt`.
 *
 * `handoff` devolve `true` quando desviou — quem chamou encerra ali. Devolve
 * `false` quando o backend não liberou, quando a resposta ainda não chegou ou
 * quando o handoff não é possível (sem token, sem URL): aí quem chamou segue
 * com a navegação normal pro JusGPT, que funciona. Nunca vira erro na tela.
 */
export function useAiPlatformHandoff(): {
  enabled: boolean;
  handoff: (options?: AiPlatformHandoffOptions) => boolean;
} {
  const { enabled } = useJusGptV2Access();

  const handoff = useCallback(
    (options?: AiPlatformHandoffOptions): boolean => {
      if (!enabled) return false;
      return openAiPlatform(options);
    },
    [enabled],
  );

  return { enabled, handoff };
}

export default useAiPlatformHandoff;
